import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import "./LoadingContainer.css";

export default function LoadingContainer() {
  return (
    <Container>
      <Row>
        <Col>
          <div className="loading-container">
            <AiOutlineLoading3Quarters className="loading-container-icon" />
            Aguarde um momento ou tente novamente mais tarde
          </div>
        </Col>
      </Row>
    </Container>
  );
}
